import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export async function exportarExcel({ rows, columns, filename = 'documento-transkyrios.xlsx' }) {
  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet('Historial');

  // Definir columnas (header, key y ancho)
  ws.columns = columns.map(c => ({
    header: c.header,
    key: c.key,
    width: c.width ?? 24
  }));

  // Estilos cabecera
  const header = ws.getRow(1);
  header.font = { bold: true };
  header.alignment = { vertical: 'middle', horizontal: 'left', wrapText: true };

  // Celdas: wrapText por defecto
  ws.columns.forEach(col => {
    col.alignment = { wrapText: true, vertical: 'top' };
  });

  // Agregar filas
  rows.forEach(r => {
    const obj = {};
    columns.forEach(c => {
      const v = c.get ? c.get(r) : r[c.key];
      obj[c.key] = v == null ? '' : v; // evita undefined/null
    });
    ws.addRow(obj);
  });

  // Congelar cabecera y autofiltro
  ws.views = [{ state: 'frozen', ySplit: 1 }];
  ws.autoFilter = {
    from: { row: 1, column: 1 },
    to:   { row: 1, column: columns.length }
  };

  // Descargar
  const buf = await wb.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  saveAs(blob, filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`);
}
